// extracted by mini-css-extract-plugin
export default {"image":"StylistChatPdpPrompt___StylistChatPdpPrompt-module__image___LJk9n"};